export default __webpack_public_path__ + "static/media/background.fa20120e.png";